// Client-side per-page SEO meta updates (picked up by Googlebot's renderer).
const DEFAULT_TITLE = "DynaQR — One QR. Every occasion. Dynamic WhatsApp QR for ₹499/year";
const DEFAULT_DESC = "DynaQR lets you create one QR code and change what people see anytime — for events, meetings and campaigns. The QR never changes. ₹499/year.";

function upsertMeta(selector, create, content) {
  if (!content) return;
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

export function htmlToText(html, max = 155) {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  const text = (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
  return text.length > max ? text.slice(0, max - 1).trimEnd() + "…" : text;
}

export function setPageMeta({ title, description, canonical } = {}) {
  const t = title || DEFAULT_TITLE;
  const d = description || DEFAULT_DESC;
  document.title = t;
  upsertMeta('meta[name="description"]', () => { const m = document.createElement("meta"); m.setAttribute("name", "description"); return m; }, d);
  upsertMeta('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; }, t);
  upsertMeta('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; }, d);
  if (canonical) {
    upsertMeta('meta[property="og:url"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; }, canonical);
    upsertCanonical(canonical);
  }
}

export function resetPageMeta() {
  setPageMeta({ title: DEFAULT_TITLE, description: DEFAULT_DESC, canonical: `${window.location.origin}/` });
}
